/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Topic_RemoveInputs */

const en_us2_coach_topic_remove = /** @type {(inputs: Coach_Topic_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the topic`)
};

const pt_br2_coach_topic_remove = /** @type {(inputs: Coach_Topic_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar o assunto`)
};

const es_419_coach_topic_remove = /** @type {(inputs: Coach_Topic_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar el tema`)
};

const pt_pt2_coach_topic_remove = /** @type {(inputs: Coach_Topic_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar o assunto`)
};

const fr_fr2_coach_topic_remove = /** @type {(inputs: Coach_Topic_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer le sujet`)
};

const de_de2_coach_topic_remove = /** @type {(inputs: Coach_Topic_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema entfernen`)
};

const it_it2_coach_topic_remove = /** @type {(inputs: Coach_Topic_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi l'argomento`)
};

/**
* | output |
* | --- |
* | "Remove the topic" |
*
* @param {Coach_Topic_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_topic_remove = /** @type {((inputs?: Coach_Topic_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Topic_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_topic_remove(inputs)
	if (locale === "es-419") return es_419_coach_topic_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_topic_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_topic_remove(inputs)
	if (locale === "de-DE") return de_de2_coach_topic_remove(inputs)
	if (locale === "it-IT") return it_it2_coach_topic_remove(inputs)
	return en_us2_coach_topic_remove(inputs)
});
export { coach_topic_remove as "coach.topic_remove" }